<template>
  <button
    type="button"
    class="flex flex-1 items-center justify-center py-2.5 transition-colors duration-150"
    :class="
      active
        ? 'text-purple-700'
        : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'
    "
    :aria-pressed="active"
    @click="emit('select')"
  >
    <slot />
  </button>
</template>

<script setup lang="ts">
defineProps({
  active: { type: Boolean, default: false },
});
const emit = defineEmits({
  select: () => true,
});
</script>
